import React, { Component } from 'react';
import { ModalHeader, ModalBody, ModalFooter, Col, Row, Button } from 'reactstrap';
import { updateServerOnDates } from './action';
import moment from 'moment';
import DatePicker from 'react-datepicker';
import Modal from '../../../components/UI/Modal/Modal';
import { toast } from 'react-toastify';
import { connect } from 'react-redux';
import { Preloading } from '../../../components/UI/Preloader/action';

const TO_DATE = 'toDate';
const FROM_DATE = 'fromDate';
const CLOSE = "CLOSE";
const SUBMIT = "SUBMIT";
const CANCEL = "CANCEL";
const PROCEED = "PROCEED";

class ServerOn extends Component {
    constructor(props, state) {
        super(props, state);
        this.state = {
            toDate: null,
            fromDate: null,
            skipServerOffDatesList: [],
            skipServerOnDatesList: [],
            confirmModal: false,
            confirmModalBody: null,
            resizeZIndex: false,
            serverOnDatesSuccess: null,
            serverOnDatesFailure: null
        }
    }

    onChangeDate = (date, type) => {
        if (type == FROM_DATE)
        {
            this.setState({fromDate: date})
        }
        else if (type == TO_DATE)
        {
            this.setState({toDate: date})
        }
    }

    getSkipServerOffFatesDates = (fromDate, toDate) => {
        let dates = []
        const theDate = new Date(fromDate)
        const endDate = new Date(toDate)
        while (theDate < endDate) {
            dates = [...dates, moment(theDate).format('DD-MM-YYYY').toString()]
            theDate.setDate(theDate.getDate() + 1)
        }
        dates = [...dates, moment(endDate).format('DD-MM-YYYY').toString()]
        return dates
    }

    getSkipServerOnDates = (fromDate, toDate) => {
        let dates = []
        let theDate = new Date(fromDate)
        let endDate = new Date(toDate)
        theDate.setDate(theDate.getDate() + 1)
        endDate.setDate(endDate.getDate() + 1)
        while (theDate < endDate) {
            dates = [...dates, moment(theDate).format('DD-MM-YYYY').toString()]
            theDate.setDate(theDate.getDate() + 1)
        }
        dates = [...dates, moment(endDate).format('DD-MM-YYYY').toString()]
        return dates
    }

    handleButton = (type) => {
        let modalMessage = "";
        let modalheader = "";
        if (type === CLOSE) {
            modalMessage = " Are you sure you wish to close ?";
            modalheader = " Closing ?";
            this.setState({ confirmModal: !this.state.confirmModal, type: type, modalMessage: modalMessage, modalheader: modalheader });
        } else {
            if (this.state.fromDate && this.state.toDate) {
                if (this.state.fromDate <= this.state.toDate) {
                    const skipServerOffDates = this.getSkipServerOffFatesDates(moment(this.state.fromDate), moment(this.state.toDate));
                    const skipServerOnDates = this.getSkipServerOnDates(moment(this.state.fromDate), moment(this.state.toDate));

                    this.setState({
                        skipServerOffDatesList: skipServerOffDates,
                        skipServerOnDatesList: skipServerOnDates
                    })
                    const formattedDates = skipServerOffDates.map((item) => <p key={item.something_unique}>{item}</p>);
                    modalheader = "Schedule Server ON time";
                    modalMessage = <div>Are you sure you wish to schedule server on dates ?<br></br> {formattedDates} </div>
                    this.setState({ confirmModal: !this.state.confirmModal, type: type, modalMessage: modalMessage, modalheader: modalheader });
                } else {
                    toast.success(
                        <div>
                            <i className="fa fa-exclamation-triangle"></i>&nbsp;From date not greater than To date.
                </div>
                    );
                }
            } else {
                toast.warn(
                    <div>
                        <i className="fa fa-exclamation-triangle"></i>&nbsp;Required Fields are empty.
            </div>
                );
            }
        }

    }

    handleConfirmModalButton = (type) => {
        if (type === PROCEED) {
            if (this.state.type === CLOSE) {
                this.props.serverDatesModal();
            } else if (this.state.type == SUBMIT) {
                const requestBody = {
                    skipServerOffDate: this.state.skipServerOffDatesList,
                    skipServerOnDate: this.state.skipServerOnDatesList
                }
                this.props.updateServerOnDates(requestBody);
                this.props.Preloading(true);
                this.setState({ resizeZIndex: true })
            }
        }
        this.setState({ confirmModal: !this.state.confirmModal });
    }

    componentDidUpdate(prevProps) {
        if (this.props.serverOnDatesSuccess !== prevProps.serverOnDatesSuccess) {
            this.props.Preloading(false);
            this.props.serverDatesModal();
            this.setState({ resizeZIndex: false })
            toast.success(
                <div>
                    <i className="fa fa-check"></i> Server ON Dates Scheduled.
                </div>
            );

        }
        if (this.props.serverOnDatesFailure !== prevProps.serverOnDatesFailure) {
            this.props.Preloading(false);
            toast.error(
                <div>
                    <i className="fa fa-exclamation-triangle"></i> Something went wrong, Please try again !
                </div>
            );

            this.setState({ resizeZIndex: false })

        }

    }

    handleDateChangeRaw = (e) => {
        e.preventDefault();
    }

    render() {
        return (<React.Fragment>

            <Modal show={this.props.open} className={(this.state.resizeZIndex || this.state.confirmModal) ? "z-index-zero serveron-modal Large-Modal" : "serveron-modal Large-Modal"} >
                <ModalHeader>Server ON Schedule</ModalHeader>
                <ModalBody>
                    <Row>
                        <Col sm='24'>
                            <Row className="text-muted">
                                <Col sm='12'>
                                    From
                                </Col>
                                <Col sm='12'>
                                    To
                                </Col>
                            </Row>
                            <Row>
                                <Col sm='12' className='date-input'>
                                    <DatePicker className="form-control datepicker-label" popperPlacement='bottom' popperModifiers={{
                                        offset: {
                                            enabled: false,
                                            offset: '30px, 20px, 10px, 0px'
                                        }
                                    }} minDate={new Date()} maxDate={null} name="From Date" onChange={(date) => this.onChangeDate(date, FROM_DATE)} onChangeRaw={this.handleDateChangeRaw} dateFormat="dd-MM-yyyy" selected={(this.state.fromDate) ? moment(this.state.fromDate) : null} placeholderText='From DD-MM-YYYY' autoComplete='off' />
                                </Col>
                                <Col sm='12' className='date-input'>
                                    <DatePicker className="form-control datepicker-label" popperPlacement='top' popperModifiers={{
                                        offset: {
                                            enabled: false,
                                            offset: '30px, 20px'
                                        }
                                    }} minDate={new Date()} maxDate={null} name="To Date" onChange={(date) => this.onChangeDate(date, TO_DATE)} onChangeRaw={this.handleDateChangeRaw} dateFormat="dd-MM-yyyy" selected={(this.state.toDate) ? moment(this.state.toDate) : null} placeholderText='To DD-MM-YYYY' autoComplete='off' />
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </ModalBody>
                <ModalFooter>
                    <Row>
                        <Col sm='12'><Button color="info" size="lg" className="justify-content-center" onClick={() => this.handleButton(CLOSE)} > Close </Button></Col>
                        <Col sm='12'><Button color="success" size="lg" className="justify-content-center" onClick={() => this.handleButton(SUBMIT)}> Schedule </Button></Col>
                    </Row>
                </ModalFooter>
            </Modal>

            <Modal show={this.state.confirmModal} className="serveron-confirm-modal Large-Modal" >
                <ModalHeader>
                    {this.state.modalheader}
                </ModalHeader>
                <ModalBody>
                    {this.state.modalMessage}
                </ModalBody>
                <ModalFooter>
                    <Col ><Button color="info" size="lg" className="justify-content-center" onClick={() => this.handleConfirmModalButton(CANCEL)} > Cancel </Button></Col>
                    <Col><Button color="success" size="lg" className="justify-content-center" onClick={() => this.handleConfirmModalButton(PROCEED)}> Proceed </Button></Col>
                </ModalFooter>
            </Modal>

        </React.Fragment>
        );
    }
}

const mapStateToProps = (state, ownProps) => ({
    serverOnDatesSuccess: state.serverOn.serverOnDatesSuccess,
    serverOnDatesFailure: state.serverOn.serverOnDatesFailure
});

const mapDispatchToProps = dispatch => ({
    updateServerOnDates: (data) => { dispatch(updateServerOnDates(data)) },
    Preloading: (data) => { dispatch(Preloading(data)) },
});

export default ServerOn = connect(mapStateToProps, mapDispatchToProps)(ServerOn)